import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class PipeImportService extends RestfulService<Models.PipeImport> {

  constructor(private restService: RestService) {
    super(Models.PipeImport);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('pipe-imports');
  }

}
